// extracted by mini-css-extract-plugin
export default {"fit-to-content-height":"TWFxr5","fitToContentHeight":"TWFxr5"};